import { CHAR_WIDTH_RATIOS, DEFAULT_CHAR_WIDTH_RATIO } from '../constants/index.es.js';

const getComponentSize = (isMobile) => {
  return isMobile ? "s" : "m";
};
const estimateTextWidth = (text, fontSize) => {
  var _a;
  let width = 0;
  const normalizedText = removeVietnameseAccents(text);
  for (const ch of normalizedText) {
    width += ((_a = CHAR_WIDTH_RATIOS[ch]) != null ? _a : DEFAULT_CHAR_WIDTH_RATIO) * fontSize;
  }
  return Math.round(width * 100) / 100;
};
const removeVietnameseAccents = (text) => {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");
};

export { estimateTextWidth, getComponentSize };
